import PropTypes from 'prop-types';
import { SVG_SERVER_URL } from '@/constants/urls';

const FooterHeaderImage = ({ name }) => <img src={`${SVG_SERVER_URL}/${name}.svg`} alt={name} width={40} loading="lazy" />;

FooterHeaderImage.propTypes = {
	name: PropTypes.string,
};

export default FooterHeaderImage;
